import type { ApolloClient } from '@apollo/client'

/**
 * Refetch all currently active watched queries without clearing the cache.
 * Use this instead of resetStore() after mutations: resetStore() clears the cache
 * and aborts in-flight operations (problematic with Apollo Client 4 and breaks auth flows).
 */
export function refetchActiveApolloQueries(apolloClient: ApolloClient): void {
  void apolloClient
    .refetchQueries({ include: 'active' })
    .catch((err: unknown) => {
      console.warn('[Apollo] refetchQueries({ include: "active" }) failed', err)
    })
}
